import { render } from "./bodyController.vue?vue&type=template&id=6941bd77"
import script from "./bodyController.vue?vue&type=script&lang=js"
export * from "./bodyController.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1146565357/src/github.com/visitorscoverage/vc-code/vue/apps/benefit-estimator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__